// this file is generated automatically by git.version.js
export const versionInfo = {
  revision: 'd680083b',
  branch: 'develop',
  datetime: '2025-09-19T22:29:52+00:00',
};
